var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Button / Right Arrow"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 158",
    x: 0.0661621,
    y: 0.536011,
    width: 39,
    height: 39,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16.0662 14.536L22.0662 20.036L16.0662 25.536",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgRightArrow;